import { createFileRoute } from '@tanstack/react-router'
import { LeaveRequestEditor } from './-LeaveRequestEditor'

// ModuleGuard is provided by the leave route.tsx layout.
export const Route = createFileRoute('/hr/leave/$id')({
  component: LeaveRequestDetailPage,
})

function LeaveRequestDetailPage() {
  const { id } = Route.useParams()
  return <LeaveRequestEditor id={id} />
}
